import React, {useMemo, useState, useEffect, useRef, useCallback} from 'react';
import { useDispatch } from 'react-redux';
import {RouteProps, useNavigate} from 'react-router';
import { Formik, Form, FormikProps } from 'formik';
import _ from 'lodash';
import qs from 'query-string';
import { Button } from 'primereact/button';
import { v4 as uuid} from 'uuid';
import {getConfig as getFormPage, resetFormId} from '@redux/formPage/actions';
import { setFormData } from '@redux/formData/actions';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ProgressBar } from 'primereact/progressbar';
import { FormHeader } from 'components';
import {FormPage, FormPageFieldComponentProps, FormPageFieldHeader, FormPageFieldInfo} from 'types/formPage';
import { getSubmissionURL } from 'helpers/getSubmissionURL';

import { getValidationSchema } from './validationSchema';
import { getFieldComponent } from './helper/getFieldComponent';
import getInitialValues from './initialValues';

import cls from './form.module.scss';
import { useParams } from 'react-router';
import { useLocation } from 'react-router';
import {useRedux, useReduxLoading, useStore} from "@redux";
import {Dropdown} from "primereact/dropdown";
import {Branding} from "../../components/Branding";
import {useFormData, useFormPage} from "../../hooks";
import {Instructions} from "../../components/Instructions";
import {
  toGridRows,
  insertFieldsState,
  insertGridsState,
  toBool,
  toString, toStyle,
  replaceFieldIds, visibleDim, renderTemplate, openUrl
} from "../../components/utils";
import Actions from "../../actions";
import {submitForm} from "../../helpers/formPage/submit";
import {ErrorBoundary, ErrorFallbackComponent} from "./errors";
import {Dialog} from "primereact/dialog";

type FormAppProps = {
  formData?: any
  mode?: string
  form_id?: number;
  record_id?: string;
  onDirty?: (id:string) => void
  formRef?: {current:any}
  path?: string[]
  count?: number
}

const FormApp = ({mode = 'live', form_id = null, record_id = null, onDirty = null,  formRef = null, path = [], count = 0}: FormAppProps) => {
  const { root_code, record_id: recordIdParam = '' } = useParams();
  const innerFormRef = useRef(null)
  const [formPath, setFormPath] = useState([])
  const [vw,vh] = visibleDim()
  const form_record_id = record_id || recordIdParam
  const history = useNavigate();
  const location = useLocation();
  const href = window.location.href
  const [formInstanceId, overrideFormInstanceId] = useState( form_record_id || uuid() )
  const [errMsg, setErrMsg] = useState(null)
  const [isSubmitting,setIsSubmitting] = useState('')
  const [displayDialog,setDisplayDialog] = useState(true);
  const [submitPressed, setSubmitPressed] = useState(false)
  const [saveAsDraftPressed, setSaveAsDraftPressed] = useState(false)
  const urlParams = new URLSearchParams(location.search)
  const params = Object.fromEntries(urlParams)
  const d = useDispatch();
  const store = useStore()
  const form = useFormPage( formInstanceId ) || {} as any
  const {data:formData,original:formDataOrig}  = useFormData( formInstanceId ) || {} as any
  const {  fields:rawFields = [], grid:rawGrid = {}, page: pageDetails = {}, collabs = [], form_code } = form?.details ?? {};
  const { header = {} as FormPageFieldHeader, submission = {}, branding = {}, instructions = {content: ''}, styling = {}, draft = {} } = pageDetails || {}
  const embed = !!form_id
  const isRoot = !!form?.details?.is_root
  const isDev = form?.details?.instance_mode === 'dev'
  const init_values = _.isEmpty(formData) ? _.get(form,'init_values', {}) : formData
  const formPageState = useRedux('formPage');
  const formDataState = useRedux('formData')
  const hideElements = toBool(_.get(params, 'form_hide')) || toBool(_.get(params, 'form_display') )
  const grid = insertGridsState( formInstanceId, rawGrid, store )
  const fields = insertFieldsState( rawFields, store )
  const gridRows = toGridRows( grid, fields )
  const gridWidth = grid.options?.maxWidth || 720

  const [isFirstTimeLoadingActions, setIsFirstTimeLoadingActions] = useState(true);


  useEffect( () => {
    setFormPath(path)
  }, [path.join('')])
  console.log("***FORM APP***", {formInstanceId, root_code, form_record_id, record_id, gridRows, form, form_id, params, formData, formPageState, formDataState, path, formPath})
  useEffect(() => {
    console.log('Getting Form Page', formInstanceId, root_code, form_record_id )
    if(_.isEmpty(form)){
      d(getFormPage( formInstanceId, root_code, mode, {id:formInstanceId, record_id:form_record_id, params, form_id} ) as any)
    }
    return () => {};
  }, [form_id]);

  useEffect( () => {
    console.log('**Form Instance Update**', {formId: form?.id, formInstanceId, formData, init_values, path})
    if(form?.id && form.record_id && form.record_id !== formInstanceId){
      console.log('Resetting Form', formInstanceId, form.id, form.record_id)
      d(resetFormId(formInstanceId, form.record_id) as any)
      overrideFormInstanceId(form.record_id)
    }
    if(form?.id && isRoot){
      document.title = form.details?.name
    }
    if(form?.id && form.id === formInstanceId){
      if(!formPath.includes(`${formInstanceId}`) && !path.includes(`${formInstanceId}`)){
        setFormPath( path.concat( [`${formInstanceId}`] ) )
      }
      console.log('Setting FORMS PATH', formPath, formInstanceId, form)
      if(_.isEmpty(formData) && !_.isEmpty(init_values)) {
        d(setFormData(formInstanceId, root_code, form_code, false, init_values, true) as any)
      }
    }
  }, [formInstanceId, form?.id, formPath, setFormPath])

  const validationSchema = useMemo(() => {
    const validation = getValidationSchema(form.record_id, fields)
    console.log('Getting Validations', fields, validation)
    return validation
  }, [fields, form.record_id]);


  const doSubmit = (isDraft = false) => {

    store.formData.data["draft"] = draft;
    store.formData.data["draft_sub"] = isDraft;
    const payload = {
      id:formInstanceId,
      params,
      record_id: form.record_id,
      form_state: {root_code,
        form_code,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,...store.formData.data}
    };
    setIsSubmitting(isDraft ? 'draft': 'submit')
    try {
      console.log('*submitForm*', {payload,root_code,mode,isDraft,formInstanceId,record:form.record_id})
      submitForm(root_code, mode, payload, result => {


          result.json().then( res => {
            console.log('SUBMISSION RESPONSE', result, res)
            setIsSubmitting('')
            setSubmitPressed(false)
            if (submission?.mode === 'redirect_url' && submission?.target && !res.error) {
              window.scrollTo(0, 0);
              openUrl( renderTemplate( submission.target, res, {render_as: 'plain'}).output, submission?.redirect_parent ? 'top' : 'self')
              // (submission?.redirect_parent ? window.top : window).location.href = renderTemplate( submission.target, res, {render_as: 'plain'}).output;
            } else {
              d(setFormData(`${formInstanceId}_submission_response`, root_code, form_code,false, {href, ...res}) as any)
              history(`/form/${isDraft ? 'draft' : 'success'}/${root_code}/${formInstanceId}`, {replace: true});
            }
          })

      }, err => {
        setIsSubmitting('')
        setSubmitPressed(false)
        setErrMsg( err.msg )
      })


    } catch (error) {
      // eslint-disable-next-line
      console.log('Error in Form Submission', error);
      setErrMsg( error.msg )
      setIsSubmitting('')
      setSubmitPressed(false)
    }finally{
    }
  };
  const onSaveAsDraft = () => {
    doSubmit(true)
  }
  const onSubmit =  () => {
    doSubmit(false)
  }
  const details = {instance:formInstanceId,root_code,form_code,mode,params,record_id: form.record_id, form_id, fields, path: formPath,collabs, store}

  const renderForm = React.useCallback(
    ({ isSubmitting:formSubmitting, values, setValues, initialValues, validateForm, errors, handleSubmit, dirty, touched}: FormikProps<typeof init_values>) => {
      useEffect( () => {

        if(!_.isEqual(formData, values) || isFirstTimeLoadingActions){
          const actions = new Actions( formInstanceId, store, d )
          if(actions.isReady()) {
            const [next, changed] = actions.processActions(initialValues, formData, values, isFirstTimeLoadingActions, form_record_id)
            d(setFormData(formInstanceId, root_code,form_code, !isFirstTimeLoadingActions, next) as any)
            if (changed) setValues(next)
            validateForm(next)
            setIsFirstTimeLoadingActions(false)
          }
          if(onDirty && !isFirstTimeLoadingActions) onDirty(formInstanceId)

        }

      }, [values,count])
      const {card = false} = styling || {}
      console.log('Rendering Form With Errors', submitPressed, touched, values, JSON.stringify(errors), styling)
      const errorsTouched = {}
      _.each(errors, (val,key) => {
        if(submitPressed || touched[key] || !_.isEmpty(values[key]))errorsTouched[key] = val
      } )
      //Avoid first render without processing Actions
      if (isFirstTimeLoadingActions) {
        return <ProgressBar mode="indeterminate"/>
      }
      return (
        <div className={embed ? cls.formFull : cls.formWrapper} style={{maxWidth: embed ? '100%' : gridWidth}}>
          {!embed && <FormHeader header={header} />}
          {errMsg && <h3 className={'p-error'}>The Following Error Occurred: {errMsg}</h3>}

          {gridRows.map( (gr, grIndex) => (
                <div key={`gr-${grIndex}`} className="grid">
                  {gr.map( (gc, gcIndex) => {
                    return !gc ? '' : (
                        <div key={`gr-${grIndex}-gc-${gcIndex}`} className={`lg:col-${gc.col.lg} md:col-${gc.col.md} col-${gc.col.sm} ${gc.offset ? `lg:col-offset-${gc.offset.lg} md:col-offset-${gc.offset.md} col-offset-${gc.offset.sm}` : ''}`}>
                          <div style={{width: '100%'}}>
                      {gc.fields.map((fieldConfigOri) => {
                        const fieldConfig = fieldConfigOri//toFieldConfig(fieldConfigOri)
                        const { enabled_parent_mapping, parent_field_id,id, type, name, title, sub_title, helper_text, placeholder, display_status } = fieldConfig;
                        const Component: React.FC<FormPageFieldComponentProps> = getFieldComponent(type);
                        const disabled = display_status?.includes('disable')

                        // if(type.includes('advance'))console.log('GC Field', type, fieldConfig, gc, Component)
                        // console.log('GC Map', fieldConfig)
                        // try {
                          return (
                              <React.Fragment key={id}>
                                <Component
                                    name={id}
                                    label={title}
                                    card={card}
                                    description={sub_title}
                                    placeholder={placeholder}
                                    display_status={display_status}
                                    controlWrapperClassName="p-fluid"
                                    helperText={helper_text}
                                    hasError={!!errors[id]}
                                    submitPressed={submitPressed}
                                    details={{
                                      ...details,
                                      field: {id, name, type, key: _.get(fieldConfig, 'url_param_key')}
                                    }}
                                    extraConfig={fieldConfig}
                                    disabled={disabled}
                                />

                              </React.Fragment>
                          );
                        // }catch(error){
                        //   console.log('Error on Field')
                        //   return <></>
                          // console.log("Field Error", id, name, type, error.toString(), error.message)
                          // return <p>Field Error: {error.message}</p>
                        // }
                      })}
                          </div>
                    </div>
                    )
                  })}
                </div>
          ))}
          <div className="flex justify-content-between">
          {!hideElements && !embed && isRoot && draft.enabled &&

              <Button label={isDev ? "Save as Draft Button disabled during development" : draft?.draft_button_label || 'Save as Draft'} loading={formSubmitting} type="button" onClick={() => {
                setSaveAsDraftPressed(true)
                onSaveAsDraft()
              }}
                      className={`col-${draft.button?.columns || submission?.button?.hidden ? 12 : 5} ${draft.button?.offset ? 'col-offset-' + draft.button?.offset : ''} p-button-info ${draft.button?.class}` }
                      style={{...(toStyle(draft?.button?.style))}}
                      disabled={isDev}
              />

          }

          {!hideElements && !embed && isRoot && !submission?.button?.hidden &&

            <Button label={isDev ? "Submit Button disabled during development" : submission?.button?.content || 'SUBMIT'} loading={formSubmitting} type="submit" onClick={() => {
              console.log('SUBMIT PRESSED')
              setSubmitPressed(true)
              handleSubmit()
            }}

                    className={`col-${submission.button?.columns || draft.enabled ? 5 : 12} ${submission.button?.offset ? 'col-offset-' + submission.button?.offset : ''} p-button-success ${submission.button?.class || ''}` }
                    style={{...(toStyle(submission?.button?.style))}}
                    disabled={isDev}
                    tooltip={submission.button?.tooltip || ''}

            />


            }
          </div>
          {_.isEmpty(errorsTouched) ? <></> : <><p className={'p-error'}>Form Errors:</p>{Object.keys(errorsTouched).map( errId => <div key={errId}>{replaceFieldIds(toString(errorsTouched[errId]), fields)}</div>)}</>}
          <div style={{height: '100px'}}/>
        </div>
      );
    },
    [fields, header, formData,setFormData, store, formInstanceId,validationSchema, isFirstTimeLoadingActions],
  );


  console.log('Checking Form State', formPageState.loadingId, formInstanceId, formPageState, form?.record_id)
  if(formPageState.isError){
    let msg = `An Error has occurred (${formPageState.error.error}). Please contact your Form Admin or try again.`
    switch(formPageState.error?.error){
        case 'record_not_found':
            msg = `No Record Found with specified Record ID or URL Param`
            break;
        case 'form_not_creatable':
          msg = `This Form is not configured for creating records. Please contact your Form Admin`
          break;
        case 'form_not_updatable':
          msg = `This Form is not configured for updating records. Please contact your Form Admin`
          break;

    }
    return <h3 className={'pl-5 pt-5'}>{msg}</h3>
  }
  if(isSubmitting) {
    console.log("***IS SUBMITTING???", isSubmitting, submitPressed)
  }
  if ( (formPageState.loadingId === formInstanceId && (formPageState.isLoading || formPageState.isInitLoading)) || isSubmitting || (form?.record_id && formInstanceId !== form.record_id) || !_.get(store.formPage.data,`${formInstanceId}.details`) ){
    console.log("***SHOWING PROGRESS BAR ON SUBMIT***", isSubmitting, submitPressed)
    return <ProgressBar mode="indeterminate"/>
  }

  if (formPageState.loadingId === formInstanceId && formPageState.isError) {
    let message = "An Internal Error has has occurred. Please try again or contact your Forms admin."
    if(formPageState.error.status === 404) message = "Form not Found. Please check URL and try again."
    return <Dialog header={ message }
                   visible={displayDialog}
                   onHide={() => setDisplayDialog(false)}
                   footer={() => {
                     return (
                         <div>
                           <Button label="OK" icon="pi pi-check" onClick={() => setDisplayDialog(false)} autoFocus/>
                         </div>
                     );
                   }
                   }
    />
  }


 console.log('RENDERING FORM DETAILS', isSubmitting)
  return (
      <>
        <ErrorBoundary>
    <Formik initialValues={init_values} innerRef={ref => {
      innerFormRef.current = ref
      if(formRef)formRef.current = ref
    }} onSubmit={onSubmit} validationSchema={validationSchema} validateOnBlur={true} validateOnChange={false}>
      {renderForm}
    </Formik>
        {!embed && isRoot && <Branding details={branding} dims={{gridWidth, vw, vh}} location={'float'}/>}
        {!hideElements && !embed && <Instructions details={instructions} dims={{gridWidth, vw, vh}}/>}
        </ErrorBoundary>
      </>

  );
};

export default FormApp;
